import { h } from "@stencil/core";
const render = () => (h("iframe", { src: "/showcase/pages/code-diff-editor.html", frameborder: "0" }));
export const codeDiffEditorShowcaseStory = {
    render: render
};
